import {ElasticSearchHit} from "@me8eon/ai.tools.utils";

const addIfExists = (field: any, label: string): string => {
    return field ? `- ${label}: ${field}\n` : "";
}


/**
 * Converts an Elasticsearch hit to a formatted string.
 * @param hit
 */

const createStringFromHit = (hit: ElasticSearchHit): string => {
    return `${addIfExists(hit._source.title, "Title")}
    ${addIfExists(hit._source.device_name, "Device Name")}
    ${addIfExists(hit._source.description, "Description")}
    ${addIfExists(hit._source.link, "Link")}
    ${addIfExists(hit._source.price, "Price")}
    ${addIfExists(hit._source.cost_type, "Cost Type")}
    ${addIfExists(hit._source.delivery_time, "Delivery Time")}
    ${addIfExists(hit._source.technical_specifications, "Technical Specifications")}
    `
}

export const createStringFromOrderItCategoryHits = (hits: ElasticSearchHit[]): string => {
    if (!hits || hits.length === 0) {
        return "No items found.";
    }

    const formattedHits = hits.map((hit, _index) => {
        return createStringFromHit(hit);
    });

    return `Here are all items found":\n\n${formattedHits.join("\n\n")}`;
};

